import React, { useEffect, useState } from "react";
import './DataTable.css';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const DataTable = ({ columns, data, readOnly, checkAll, recalculaMargemMkp, onlyChecked, setColumn, gravaPosicaoColunas, onFieldChange }) => {

  const [form, setForm] = useState(data);

  useEffect(() => {
    setForm(data);
  }, [data])

  const countSubstr = (string, subString, allowOverlapping) => {
    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  }


  const onChangeInput = (e, idx) => {
    let frm = [...form];
    let value = e.target.value;

    columns.map(col => {
      if (col.datafield == e.target.name && col.currency) {
        // Remove o prefixo "R$ ", troca vírgula por ponto, permite só dígitos e um ponto
        value = value.replace('R$ ', '').replace(/,/g, '.').replace(/[^0-9.]/g, '');
        const dotIdx = value.indexOf('.');
        if (dotIdx !== -1) {
          value = value.slice(0, dotIdx + 1) + value.slice(dotIdx + 1).replace(/\./g, '');
        }
      }
    });

    frm[idx][e.target.name] = value;
    setForm(frm);
    recalculaMargemMkp();
  }

  const onBlurInput = (e, idx) => {
    let frm = [...form];

    columns.map(col => {
      if (col.datafield == e.target.name && col.currency) {
        const num = parseFloat(frm[idx][col.datafield]);
        frm[idx][col.datafield] = isNaN(num) ? '' : num.toFixed(2);
      }
    });

    setForm(frm);

    if (onFieldChange) {
      onFieldChange(frm[idx].produto_id, e.target.name, frm[idx][e.target.name]);
    }
  }

  const onChangeCB = (e, idx) => {
    let frm = [...form]

    let checked = e.target.checked;

    frm[idx].checked = checked;

    setForm(frm);
  }

  const onChangeCheckAll = (e) => {
    checkAll(e.target.checked);
    // let frm = [...form] 

    // frm.map(linha=>{
    //   linha.checked = e.target.checked
    // })

    // setForm(frm);
  }

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: 8,
    width: 250
  });

  const onDragEnd = (e) => {
    // console.log(e)
    if(e.destination != null){
      let origIdx = e.source.index;
      let destIdx = e.destination.index;

      let newCol = [];
        
      let oldSource = columns[origIdx];
      let oldDest   = columns[destIdx];
  
      columns.map((col,i)=>{
        if(i != origIdx){
          newCol.push(col) 
        }
        // if(i == destIdx){
        //   newCol.push(oldSource);
        //   console.log(destIdx)
        //   // newCol.push(oldDest)
        //  }else 
        // if(i == positon){
        //   newCol.push(oldDest);
        //   console.log(positon)
        // }else if((origIdx < destIdx )&&(i != positon)){
        //   newCol.push(col)
        // }else{
        //   newCol.push(col)
        // }
        // console.log(col)
      }) 
      newCol.splice(destIdx,0,oldSource);   
      gravaPosicaoColunas(newCol);
      setColumn(newCol);     
    }  
  }

  return (
    <div className={'container-table'}> 
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable 
          droppableId="droppable" 
          direction="horizontal"
        >
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}            
              // style={getListStyle(provided.isDraggingOver)}              
              // {...provided.droppableProps}
              // {...provided.placeholder}
              // {...provided}
              className={'header-row'}
            >                 
              {/* <div > */}              
                { columns && columns.map((coluna, idx) =>{
                  if(coluna.visible == true){              
                    return(
                      <Draggable key={idx} draggableId={`${idx}`} index={idx}>
                        {(provided, snapshot) => (
                          <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}  
                          key={`col-header${coluna.datafield}`}
                              // className={'header-column-cell'}
                              // style={{width:coluna.width, textAlign: coluna.align}}                          
                          >                   
                            <div style={{width:coluna.width, textAlign: coluna.align}} className={'header-column-cell'}>                        
                            {coluna.checkbox &&
                              <input
                                type="checkbox"
                                onChange={onChangeCheckAll}
                              ></input>
                            }
                            {coluna.text}
                          </div>
                          </div>
                        )}
                      </Draggable>
                    )
                  }
                }
                )}
              {/* </div> */}
              {provided.placeholder} 
            </div>
          )}
        </Droppable>
      </DragDropContext>

      {data && data.map((linha, idx) => {
        if (((onlyChecked == true) && (linha.checked)) || (onlyChecked == false)) {
          return (
            <div
              key={`row-grupo-${idx}`}
              className={'row-grupo row-data-grid ' + ((idx % 2 == 0) ? '' : 'row-color')}>
              <div
                key={`row-${idx}`}
                style={{ display: 'flex' }}
              >
                {columns.map((col, colIdx) =>
                col.visible == true &&
                  <div key={`group-col-${colIdx}`}>                        
                    {(col.editable && !readOnly && linha.checked) &&
                      <div
                        key={`col-${colIdx}`}
                        // className={[styles.columnCell,styles.rowColor]}
                        className={'column-cell edit-dtable'}
                        style={{ width: col.width, textAlign:col.align }}
                      >
                        <input
                          name={col.datafield}
                          value={
                            col.currency && linha[columns[colIdx].datafield] !== ""
                              ? `R$ ${linha[columns[colIdx].datafield]}`
                              : (linha[columns[colIdx].datafield] ?? '')
                          }
                          className={"input-edit-dtable"}
                          style={{ textAlign: col.align }}
                          onChange={(e) => { onChangeInput(e, idx) }}
                          onBlur={(e) => { onBlurInput(e, idx) }}
                          onFocus={(e) => { e.target.select() }}
                          onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur() }}
                        ></input>
                      </div>
                    }                    
                    {(!col.editable || readOnly || !linha.checked) &&
                      <div
                        key={`col-${colIdx}`}
                        // className={[styles.columnCell,styles.rowColor]}
                        className={'column-cell'}
                        style={{ width: col.width, textAlign: col.align }}
                      >
                        {col.checkbox && <input type="checkbox" onChange={(evt) => { onChangeCB(evt, idx) }} checked={linha.checked}></input>}
                        {col.currency && `R$ ${linha[columns[colIdx].datafield] ?? ''}`}
                        {col.sufix && `${linha[columns[colIdx].datafield] ?? ''} ${col.sufix}`}
                        {!col.sufix && !col.currency && (linha[columns[colIdx].datafield] ?? '')}
                      </div>
                    }
                  </div>
                )}
              </div>
              <span className={'prod-name'}>{linha.produto}</span>
              <span className={'prod-name'}>{linha.apresentacao}</span>
            </div>
          )
        }
      }
      )}
    </div>


    // <div className={styles.containerTable}>
    //   <table>
    //     <thead>
    //       <tr>
    //         {columns.map(coluna =>
    //           <th
    //             key={coluna.dataField}
    //             className={styles.headerColumnCell}>
    //             {coluna.text}
    //           </th>
    //         )}
    //       </tr>
    //     </thead>

    //     <tbody>
    //       {data.map((linha, idx) =>

    //         <tr
    //           key={`row${idx}`}
    //         >
    //           {columns.map((col, colIdx) =>
    //               <td
    //                 key={`col${colIdx}`}
    //                 className={[styles.columnCell]}
    //               >
    //                 <div>
    //                   <span style={{display:"block"}}>{linha[columns[colIdx].dataField]}</span>
    //                   {colIdx == 0 &&
    //                     <span style={{width:'200px',display:"block"}}>{linha.produto}</span>
    //                   }
    //                 </div>
    //               </td>
    //           )}
    //         </tr>

    //       )}
    //     </tbody>

    //   </table>
    // </div>
  )
}

export default DataTable;